import { render, staticRenderFns } from "./actPDFAlfakodo.vue?vue&type=template&id=63618b4d"
import script from "./actPDFAlfakodo.vue?vue&type=script&lang=js"
export * from "./actPDFAlfakodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports